<div class="d-flex flex-row flex-auto">
  <div class="industry-influencers" *ngIf="industryPieChartData">
    <achoo-pie-chart [chartData]="industryPieChartData"
                     [chartTitle]="'measure.industry_influencer' | translate"
                     [height]="chartHeight"
                     [pieInnerSize]="chartInnerSize"
                     [pieSize]="pieSize"
                     [pieCenter]="pieCenter"
                     [titleStyling]="chartTitleStyling"
                     [listLegendPlaceholder]="['Technology', 'Apparel', 'Media', 'Travel', 'Automotive']"
                     [legend]="chartLegend">
    </achoo-pie-chart>
  </div>
  <div class="industry-topic" *ngIf="industryLineData">
    <achoo-column-chart [chartData]="industryLineData "
                        [titleStyling]="chartTitleStyling"
                        [chartTitle]="'measure.industry_engagement' | translate"
                        [height]="chartHeight">
    </achoo-column-chart>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/industry-drill-down-report/industry-drill-down-report.component.html